import React, { useRef } from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'

import { MAP_SETTINGS_IMAGES } from '../../../assets'

import MapSettingsMenu from './MapSettingsMenu'
import LayersIcon from '../../common/icons/LayersIcon'
import useClickOutside from '../../common/useClickOutside'

const layerImageMap = {
  googleSatellite: MAP_SETTINGS_IMAGES.GOOGLE_SATELLITE_LAYER,
  googleTerrain: MAP_SETTINGS_IMAGES.GOOGLE_TERRAIN_LAYER,
  googleRoadmap: MAP_SETTINGS_IMAGES.GOOGLE_ROADMAP_LAYER,
  openStreet: MAP_SETTINGS_IMAGES.OPEN_STREET_LAYER,
  bingRoads: MAP_SETTINGS_IMAGES.GOOGLE_ROADMAP_LAYER,
  bingGray: MAP_SETTINGS_IMAGES.GOOGLE_ROADMAP_LAYER,
  bingAerial: MAP_SETTINGS_IMAGES.GOOGLE_SATELLITE_LAYER,
  bingHybrid: MAP_SETTINGS_IMAGES.GOOGLE_HYBRID_LAYER,
  googleHybrid: MAP_SETTINGS_IMAGES.GOOGLE_HYBRID_LAYER
}

const LayerSettings = ({ uiStore, t }) => {
  const layerSettingsRef = useRef(null)

  useClickOutside(layerSettingsRef, () => uiStore.hideLayerSettings(), uiStore.isLayerSettingsVisible)

  const handleLayerBtnClick = () => {
    uiStore.toggleLayerSettings()
  }

  return (
    <div ref={layerSettingsRef} className='layer-settings'>
      <button className='layer-settings__btn' type='button' onClick={handleLayerBtnClick}>
        <img className='layer-settings__img' src={layerImageMap[uiStore.baseMap]} alt='Layer image' />
        <span className='layer-settings__info'>
          <LayersIcon />
          <span className='layer-settings__name'>{t('GLOBAL.LAYERS')}</span>
        </span>
      </button>
      {uiStore.isLayerSettingsVisible && <MapSettingsMenu />}
    </div>
  )
}

export default withTranslation()(inject('uiStore')(observer(LayerSettings)))
